/* eslint-disable prefer-destructuring */
import { GetServerSideProps, NextPage } from 'next';

import { AppProvider } from '../src/providers/app';
import { CallMapBoard } from '../board';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const companyTag = ctx.query.companyTag as string;

  if (companyTag) {
    return { props: { tag: companyTag } };
  }

  return { notFound: true };
};

const Board: NextPage<{ tag: string }> = ({ tag }) => {
  return (
    <AppProvider tag={tag}>
      <CallMapBoard />
    </AppProvider>
  );
};

export default Board;
